import { Route } from '@angular/router';
import {
    CtepContentComponent,
    CtepFooterComponent,
    CtepHeaderComponent,
    CtepLayoutComponent,
} from '@kempower-nx-workspace/ctep-event-log-app-core';
import {
    EventLogPageNotFoundComponent,
    eventLogPageRoutes,
} from '@kempower-nx-workspace/ctep-event-log-page';

export const NOT_FOUND_PATH = 'page-not-found';

export const ctepEventLogShellRoutes: Route[] = [
    {
        path: '',
        component: CtepLayoutComponent,
        children: [
            {
                path: '',
                component: CtepHeaderComponent,
                outlet: 'header',
            },
            {
                path: '',
                component: CtepContentComponent,
                children: eventLogPageRoutes,
            },
            {
                path: '',
                component: CtepFooterComponent,
                outlet: 'footer',
            },
        ],
    },
    {
        path: NOT_FOUND_PATH,
        component: EventLogPageNotFoundComponent,
        data: {
            title: 'Page not found',
        },
    },
    {
        path: '**',
        redirectTo: NOT_FOUND_PATH,
    },
];
